import * as firebase from 'firebase';

var config = {
  apiKey: "AIzaSyA4gLZ_qM1of0faPDs8j2ezkI9l8g487Jo",
  authDomain: "forms-test-ba33d.firebaseapp.com",
  databaseURL: "https://forms-test-ba33d.firebaseio.com",
  projectId: "forms-test-ba33d",
  storageBucket: "forms-test-ba33d.appspot.com",
  messagingSenderId: "572183379231"
};
firebase.initializeApp(config);


const firebaseDb = firebase.database();
const googleAuth = new firebase.auth.GoogleAuthProvider();
const fbManufacturers = firebase.database().ref('manufacturers');
const fbProducts = firebase.database().ref('products');
const fbLooper = (snap) => {
  const data = [];
  snap.forEach((child)=>{
      data.push({
          ...child.val(),
          id:child.key
      });
  });
  return data;
}
export {
    firebase,
    firebaseDb,
    googleAuth,
    fbManufacturers,
    fbProducts,
    fbLooper
  }


// WEBPACK FOOTER //
// ./src/firebase.js